export const blogData = [ 
    
    {
        id: 24,
        "title": "Connect Atlassian MCP to Claude Code in 5 Steps",
        "description": "A practical guide on registering and connecting the Atlassian Model Context Protocol (MCP) server to Claude Code.",
        "date": "Mar 31, 2026",
        "image": "https://miro.medium.com/v2/resize:fit:1400/format:webp/1*m4XJR0g0cKSmAwPQ-qmGHQ.png",
        "url": "https://medium.com/@praveenmistry/connect-atlassian-mcp-to-claude-code-in-5-steps-9cad37da9ad5"
    }, 
    {
        id: 25,
        "title": "🤖 I Built an AI PR Review Agent for My Daily Engineering Work",
        "description": "An exploration of how I automated parts of my daily workflow by building an AI-powered agent for pull request reviews.",
        "date": "May 2, 2026",
        "image": "https://miro.medium.com/v2/resize:fit:1400/format:webp/1*GRQ8Oui1_CP49n7cDL9Ipg.png",
        "url": "https://medium.com/@praveenmistry/i-built-an-ai-pr-review-agent-for-my-daily-engineering-work-bb5cb54b1f8e"
    },
    {
        id: 26,
        "title": "I Got Tired of p-limit's Limitations, So I Built My Own — promise-cap",
        "description": "A deep dive into building a zero-dependency async concurrency library from scratch, featuring priority queues, AbortSignal, and deadlock detection.",
        "date": "May 3, 2026",
        "image": "https://miro.medium.com/v2/resize:fit:1400/format:webp/1*H6BwpHxhO2C_b6pxjBz9Bg.png",
        "url": "https://medium.com/@praveenmistry/i-got-tired-of-p-limits-limitations-so-i-built-my-own-promise-cap-bcca7f987395"
    },
    {
        id: 23,
        "title": "Connecting Figma to Claude Code: From Design to Development in One Terminal",
        "description": "Instructions on bridging the gap between design and development by integrating Figma with Claude Code via MCP.",
        "date": "Mar 31, 2026",
        "image": "https://miro.medium.com/v2/resize:fit:1400/format:webp/1*QixJNTUVYbIys4FdxCuYeA.png",
        "url": "https://medium.com/@praveenmistry/connecting-figma-to-claude-code-from-design-to-development-in-one-terminal-bfd94f07d82e"
    },
    {
        id: 22,
        "title": "Tree BFS | Javascript | Patterns to ACE any code | Part-7",
        "description": "Part of a series on coding interview patterns, focusing on identifying and implementing Breadth-First Search for trees in JavaScript.",
        "date": "Sep 22, 2025",
        "image": "https://miro.medium.com/v2/resize:fit:1400/format:webp/0*EUX7d-8qn4UY_LnE",
        "url": "https://medium.com/@praveenmistry/tree-bfs-javascript-patterns-to-ace-any-code-part-7-3532f2670923"
    },
    {
        id: 21,
        "title": "Kubernetes Pod YAML Explained: A Practical Guide Using Node.js & AWS EKS",
        "description": "A practical guide to crafting Kubernetes Pod YAML for Node.js apps on AWS EKS, breaking down essential configurations.",
        "date": "May 23, 2025",
        "image": "https://miro.medium.com/v2/resize:fit:1400/format:webp/0*qhMJ4TjRKMl2Be9R",
        "url": "https://medium.com/@praveenmistry/kubernetes-pod-yaml-explained-a-practical-guide-using-node-js-aws-eks-89ee9bfe1cfa"
    },
    {
        id: 20,
        "title": "The Silent Threat in Your npm install: A Wake-Up Call for Node.js Developers",
        "description": "Exposes hidden security risks in npm install and offers crucial practices to secure Node.js projects from malicious dependencies.",
        "date": "May 16, 2025",
        "image": "https://miro.medium.com/v2/resize:fit:1400/format:webp/0*J7x4fKpO13EbrMzt",
        "url": "https://medium.com/@praveenmistry/the-silent-threat-in-your-npm-install-a-wake-up-call-for-node-js-developers-64c94bdc0302"
    },
    {
        id: 19,
        "title": "Mastering MongoDB Indexing: Build the Perfect Index with the ESR Rule",
        "description": "Optimizing MongoDB queries by mastering the ESR (Equality, Sort, Range) rule for efficient index creation and improved performance.",
        "date": "May 12, 2025",
        "image": "https://miro.medium.com/v2/resize:fit:1400/format:webp/0*u5CmMxBY1nkxQYux",
        "url": "https://medium.com/@praveenmistry/mastering-mongodb-indexing-build-the-perfect-index-with-the-esr-rule-88419d3fa992"
    },
    {
        id: 18,
        "title": "Hidden Performance Pitfall in Node.js: Reading from process.env Inside Loops",
        "description": "Uncovers a performance bottleneck in Node.js related to process.env access within loops, providing solutions for faster applications.",
        "date": "May 10, 2025",
        "image": "https://miro.medium.com/v2/resize:fit:1400/format:webp/0*7tQ9V3SkpUTDp7KK",
        "url": "https://medium.com/@praveenmistry/hidden-performance-pitfall-in-node-js-reading-from-process-env-inside-loops-e57ea355c663"

    },
    {
        "id": 17,
        "title": "Different Ways to Clean Up: Garbage Collection Algorithms",
        "description": "Explores diverse garbage collection algorithms, detailing how they manage memory in programming languages and their performance implications.",
        "date": "May 4, 2025",
        "image": "https://miro.medium.com/v2/resize:fit:1400/format:webp/0*EUX7d-8qn4UY_LnE",
        "url": "https://medium.com/@praveenmistry/different-ways-to-clean-up-garbage-collection-algorithms-acf825285f59"
    },
    {
        id: 16,
        title: 'Understanding Rate Limiting: Concepts and Algorithms',
        description: 'Delves into rate limiting for web applications and APIs, explaining key concepts and various algorithms for effective traffic management.',
        date: 'April 26, 2025',
        image: 'https://miro.medium.com/v2/resize:fit:1400/format:webp/0*F35NLpFiCp41o2Bd',
        url: 'https://medium.com/@praveenmistry/understanding-rate-limiting-concepts-and-algorithms-fce4b7c2d7eb'
    },
    {
        id: 15,
        title: 'Rebootify — A 30x Lightweight Alternative to Nodemon!',
        description: 'Rebootify is a CLI tool designed to automatically restart Node.js applications when file changes are detected.',
        date: 'Mar 19, 2025',
        image: 'https://miro.medium.com/v2/resize:fit:1400/format:webp/0*mh_8UUxhXmaXGEcE',
        url: 'https://medium.com/@praveenmistry/rebootify-a-30x-lightweight-alternative-to-nodemon-b343faa78eee'
    },
    {
        id: 14,
        title: 'Cross-Origin Resource Sharing (CORS)',
        description: 'The article provides an overview of Cross-Origin Resource Sharing (CORS), explaining its purpose and how it allows or restricts web applications from making requests to resources on different domains.',
        date: 'Nov 19, 2024',
        image: 'https://miro.medium.com/v2/resize:fit:1400/format:webp/0*HczbXCpmOUG9zLc6',
        url: 'https://medium.com/@praveenmistry/cross-origin-resource-sharing-cors-ab45e06ce661'
    },
    {
        id: 13,
        title: 'Git | Copy commit from one branch to another without using git merge',
        description: 'The article explains how to copy a specific commit from one branch to another in Git without using git merge, by using git cherry-pick',
        date: 'Nov 14, 2022',
        image: 'https://miro.medium.com/v2/resize:fit:1400/format:webp/0*Z9GXcyvcinqZhw8n',
        url: 'https://medium.com/@praveenmistry/git-copy-commit-from-one-branch-to-another-without-using-git-merge-132aaa5479d1'
    },
    {
        id: 12,
        title: 'AVL Tree | Javascript | Part-6.5',
        description: 'Introduction article to the data structure. AVL Tree concept with practical examples applied to the Javascript language.',
        date: 'Oct 21, 2022',
        image: 'https://cdn-images-1.medium.com/max/1600/0*YHaFWqBhqZYysqg9',
        url: 'https://medium.com/@praveenmistry/avl-tree-javascript-part-6-5-960a6f718f93'
    },
    {
        id: 11,
        title: 'Trie Tree | Javascript | Part-6.4',
        description: 'Introduction article to the data structure. Trie Tree concept with practical examples applied to the Javascript language.',
        date: 'Oct 17, 2022',
        image: 'https://miro.medium.com/max/1400/0*RUaXVgdayNSjX38w',
        url: 'https://medium.com/@praveenmistry/trie-javascript-part-6-4-c3a080c18eb3'
    },
    {
        id: 10,
        title: 'Heap | Javascript | Part-6.3',
        description: 'Introduction article to the data structure. Heap Tree concept with practical examples applied to the Javascript language.',
        date: 'Oct 14, 2022',
        image: 'https://miro.medium.com/max/1400/1*KkdIOnV4Dy3n0Lnl1pDOdA.jpeg',
        url: 'https://medium.com/@praveenmistry/heaps-javascript-part-6-3-d8c1b20c2d5a'
    },
    {
        id: 9,
        title: 'Binary Tree | Javascript | Part-6.2',
        description: 'Introduction article to the data structure. Binary Tree concept with practical examples applied to the Javascript language.',
        date: 'Oct 10, 2022',
        image: 'https://miro.medium.com/max/1400/1*KaXxfiC7RKImXt1--ORUHQ.jpeg',
        url: 'https://medium.com/@praveenmistry/binary-tree-javascript-part-6-2-79db4b7d67b2'
    },
    {
        id: 8,
        title: 'Tree | Javascript | Part-6.1',
        description: 'Introduction article to the data structure. Tree concept with practical examples applied to the Javascript language.',
        date: 'Oct 3, 2022',
        image: 'https://miro.medium.com/max/1400/1*I3XYVDxMVKYw1c8xAhGzOA.jpeg',
        url: 'https://medium.com/@praveenmistry/tree-javascript-part-6-1-79b5bfdbbc69'
    },
    {
        id: 7,
        title: 'Hash Table | Javascript | Part-5',
        description: 'Introduction article to the data structure. Hash Table concept with practical examples applied to the Javascript language.',
        date: 'Sep 30, 2022',
        image: 'https://miro.medium.com/max/1400/0*IDtfnpEraN2Hq8tV',
        url: 'https://medium.com/@praveenmistry/hash-table-javascript-part-5-337a0dfd80d2'
    },
    {
        id: 6,
        title: 'Set | Javascript | Part-4',
        description: 'Introduction article to the data structure. Set (Object) concept with practical examples applied to the Javascript language.',
        date: 'Sep 26, 2022',
        image: 'https://miro.medium.com/max/1400/0*d-FfPNnt9UievWAB',
        url: 'https://medium.com/@praveenmistry/set-javascript-part-4-cdc31eedf633'
    },
    {
        id: 5,
        title: 'Circular Linked Lists | Javascript | Part-3.3',
        description: 'Introduction article to the data structure. Circular Linked List concept with practical examples applied to the Javascript language.',
        date: 'Sep 23, 2022',
        image: 'https://miro.medium.com/max/1400/0*cT584cTSQhDHKmtu',
        url: 'https://medium.com/@praveenmistry/circular-linked-lists-javascript-part-3-3-6bffe07fb8e8'
    },
    {
        id: 4,
        title: 'Doubly Linked List | Javascript | Part-3.2',
        description: 'Introduction article to the data structure. Doubly Linked List concept with practical examples applied to the Javascript language.',
        date: 'Sep 20, 2022',
        image: 'https://miro.medium.com/max/1400/1*mnx9p20kln-L9l8tfvW7fg.jpeg',
        url: 'https://medium.com/@praveenmistry/doubly-linked-list-javascript-part-3-2-1209068fb788'
    },
    {
        id: 3,
        title: 'Linked List | Javascript | Part-3.1',
        description: 'Introduction article to the data structure. Linked List concept with practical examples applied to the Javascript language.',
        date: 'Sep 16, 2022',
        image: 'https://miro.medium.com/max/1400/1*7Mgv-k64ZK_xZUGeZ60BmQ.jpeg',
        url: 'https://medium.com/@praveenmistry/linked-list-javascript-part-3-1-d504f0c9b54e'
    },
    {
        id: 2,
        title: 'Queue | Javascript | Part-2',
        description: 'Introduction article to the data structure. Queue concept with practical examples applied to the Javascript language.',
        date: 'Sep 10, 2022',
        image: 'https://miro.medium.com/max/1400/1*uRpXar4J4e3IV76X4K9ekA.jpeg',
        url: 'https://medium.com/@praveenmistry/queue-javascript-part-2-5dab626110aa'
    },
    {
        id: 1,
        title: 'Stack | Javascript | Part-1',
        description: 'Introduction article to the data structure. Stack concept with practical examples applied to the Javascript language.',
        date: 'Sep 7, 2022',
        image: 'https://miro.medium.com/max/1400/1*8hMewp1C9JU4POLqT2xaoQ.jpeg',
        url: 'https://medium.com/@praveenmistry/stack-javascript-part-1-15f9e6ebecd5'
    },
]




// Do not remove any fields.
// Leave it blank instead as shown below.


/* 
{
    id: 1,
    title: 'Car Pooling System',
    description: '',
    date: 'Oct 1, 2020',
    image: '',
    url: 'https://preview.colorlib.com/theme/rezume/'
}, 
*/